export default __webpack_public_path__ + "static/media/Rambla-Regular.1b5c1892.ttf";